module.exports = __webpack_public_path__ + "img/Event_Name.1adf999a.png";